<script>
import { Form } from 'tortilla';
import BaseForm from './base-form';
import { mapGetters } from 'vuex';

export default {
    data: function() {
        return {
            ...BaseForm.data(),
            //url: '/my-favorites/register/modal',
            persistents: {},
            fields: this.modalFields
        }
    },

    props: {
        show: null,
        modalFields: {
          type: Object,
          default: function() { return {} }
        },
    },

    // props: [
    //     'show',
    //     'fields'
    // ],

    mounted() {
        this.boot();
        this.$validator.errors.clear();
    },

    computed: {
        ...BaseForm.computed,
        ...mapGetters({
            modalData: 'modal/getData'
        })
    },

    watch: {
        ...BaseForm.watchers
    },

    methods: {
        ...BaseForm.methods,

        submit(event) {
            this.beforeSubmit().then((token) => {
                this.form.post(event.target.action, {
                    ...this.fields, ...this.persistents,
                    'g-recaptcha-response': token
                })
                .then(response => this.success(response, event))
                .catch(() => this.failure());
            });
        },

        success(response, event) {
            this.clear();
            this.modalData.el.click();
            this.$eventsBus.$emit('close-modal');
        },

        clear() {
            this.toggleForm();
            this.$validator.errors.clear();
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/components/forms/my-favorites-modal-register-form.vue